import React from 'react';

import styled from '@emotion/styled';

import Stars from '../../../components/Badge/Stars';
import CustomHorizontalBarChat from '../../../components/Charts/CustomHorizontalBarChat';
import { useAppSelector } from '../../../redux/store';

const RatingTripLog = () => {
  const { dashboardStatsData } = useAppSelector((state) => state.dashboardData);

  const ratingTripLogData = [
    { stars: '5★', value: 54, color: '#4ADE80' },
    { stars: '4★', value: 20, color: '#A3E635' },
    { stars: '3★', value: 36, color: '#FBBF24' },
    { stars: '2★', value: 54, color: '#FB923C' },
    { stars: '1★', value: 40, color: '#F87171' },
  ];

  return (
    <Container>
      <Label>Ratings and Trip logs</Label>

      <StatsArea>
        <Card>
          <CardHeader>Total company ratings</CardHeader>

          <ContentArea>
            <Stars numStars={3} />{' '}
            <StarNum>
              <StarsGot>4.2 </StarsGot>/ 5.0
            </StarNum>
          </ContentArea>

          <CardFooter>Based on 248 ratings</CardFooter>
        </Card>

        {/* Card 2 */}
        <Card>
          <CardHeader>Total trip logs</CardHeader>

          <ContentArea className='smaller-mb'>
            {dashboardStatsData?.listedDrivers ?? 0}
          </ContentArea>

          <CardFooter>Trips logged to date</CardFooter>
        </Card>
      </StatsArea>

      <CustomHorizontalBarChat
        leftLabelKey='stars'
        data={ratingTripLogData}
        dataKey={'value'}
        colorKey='color'
        description='Rating breakdown'
        leftLabelWidth='24px'
        // marginLeft='0px'
        marginRight='10px'
      />
    </Container>
  );
};

export default RatingTripLog;

const Container = styled.div`
  display: flex;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 16px 24px;
  gap: 20px;
  border-radius: 8px;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
`;

const StatsArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  gap: 24px;
`;

const ContentArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 4px;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  color: #232222;

  &.smaller-mb {
    margin-bottom: 4px;
  }
`;

const StarNum = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StarsGot = styled.div`
  font-weight: 600;
  font-size: 10px;
  line-height: 10px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 14px 12px;
  border-radius: 8px;
  justify-content: center;
`;

const CardHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  margin: auto;
`;

const CardFooter = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin: auto;
`;
